import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from "@/components/uploadImagetow";
import { bagItemList } from "@/api/dataAll/dataAll";
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
export default {
  name: "property",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      upData: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.upData.game_id = _this.rawData.game_id;
              _this.paramsData.game_id = _this.rawData.game_id;

              _this.getList(1);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    // handleCurrentChange(val) {
    //   this.paramsData.page = val;
    //   this.getList();
    // },
    getList: function getList(e) {
      var _this2 = this;

      this.reqLoading = true;
      bagItemList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.PrimitiveData = res.data;
          _this2.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this2.tableData = _this2.currentChangePage(_this2.pageSize, _this2.currentPage);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    Refresh: function Refresh() {
      this.list = [];
      this.getList(1);
    },
    // 删除配置
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('itemIdLabel'),
        prop: "item_id"
      }, {
        label: this.$t('nameLabel'),
        prop: "item_name"
      }];
      var data = [{
        item_id: "item_id",
        item_name: "item_name"
      }].concat(_toConsumableArray(this.PrimitiveData));
      this.$export.csv({
        columns: columns,
        data: data,
        noHeader: true,
        title: this.$route.meta.title
      });
    }
  }
};